import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Col, Row } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import { faRectangleList, faMagnifyingGlass, faFilter } from "@fortawesome/free-solid-svg-icons";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PulseLoader } from "react-spinners";
import ModalLeger from './modal/legerHead';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 38px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 13px;
  //   outline:none;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }

  .wali-kelas-label{
    font-size: 13px;
    font-weight: 600;
    color: #2e52aeff;
    margin-top: 12px;
  }
`;

export default function LegerHead() {
  document.title = "Leger";

  const [savingId, setSavingId] = useState(null);

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  const [loading, setLoading] = useState(false);
  const firstLoadDone = useRef(false);

  const storageLevel = localStorage.getItem("level");
  const storageSchoolId = localStorage.getItem("ysb_school_id");
  const storageBranch = localStorage.getItem("ysb_branch_id");

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [loadingDimensi, setLoadingDimensi] = useState(true);
  const dimensiRequestRef = useRef(0);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);

  // Master: Tingkatan + Kelas
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  // Table data
  const [getData, setGetData] = useState([]);

  // Search (frontend)
  const [searchKeyword, setSearchKeyword] = useState("");

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_grade_level_id: "", 
    ysb_kelas_id: "",       
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_teacher_id: "",
  });

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
      setPermission({ create: 1, read: 1, update: 1, delete: 1 });
      return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
      setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
      });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // =========================
  // INIT: Semester
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const semesterRes = await APIMS.get(
        `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        { ...fetchParams, signal: controller.signal }
      );

      if (!isMounted.current) return;
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((sem) => Number(sem?.status) === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }
    } catch (err) {
      if (err?.name !== "CanceledError" && err?.name !== "AbortError") {
        swal({ title: "Failed", text: err?.response?.data?.message || err.message || "Error", icon: "error" });
      }
    } finally {
      if (isMounted.current) setLoading(false);
    }
  }, [descending, fetchParams, keyword, limit, page]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  const selectedSemester = useMemo(
    () => getDataSemesterMap.find((sem) => String(sem?.id) === String(form2.ysb_semester_id)) || null,
    [getDataSemesterMap, form2.ysb_semester_id]
  );

  // Dimensi bergantung pada semester, sekolah, dan tingkatan yang sedang dipilih.
  useEffect(() => {
    const requestId = ++dimensiRequestRef.current;
    const semesterId = form2.ysb_semester_id;
    const gradeLevelId = form2.ysb_grade_level_id;

    if (!semesterId || !storageSchoolId || !gradeLevelId) {
      setGetDataDimensi([]);
      setForm2((prev) => prev.ysb_dimensi_id ? { ...prev, ysb_dimensi_id: "" } : prev);
      setLoadingDimensi(!semesterId || loadingLevel || (getDataLevel.length > 0 && !gradeLevelId));
      return;
    }

    const academicYearId = selectedSemester?.ysb_academic_year_id ??
      selectedSemester?.academic_year_id ??
      selectedSemester?.ysb_academic_year?.id ?? "";

    const params = {
      page: 1,
      limit: 10,
      ascending: 1,
      search: "",
      branch: "",
      level: storageLevel || "",
      ysb_academic_year_id: academicYearId,
      ysb_semester_id: semesterId,
      ysb_branch_id: storageBranch || "",
      ysb_school_id: storageSchoolId,
      ysb_grade_level_id: gradeLevelId,
      ysb_teacher_id: "",
    };

    const controller = new AbortController();
    setLoadingDimensi(true);
    setGetDataDimensi([]);
    setForm2((prev) => prev.ysb_dimensi_id ? { ...prev, ysb_dimensi_id: "" } : prev);

    const fetchDimensi = async () => {
      try {
        const response = await APILA.get("/api/access/dimensis", {
          ...fetchParams,
          params,
          signal: controller.signal,
        });
        if (!isMounted.current || requestId !== dimensiRequestRef.current) return;
        const dims = (Array.isArray(response?.data?.data) ? response.data.data : [])
          .filter((d) => d?.status === undefined || Number(d.status) === 1);
        setGetDataDimensi(dims);
        setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0]?.id || "" }));
      } catch (err) {
        if (!controller.signal.aborted && requestId === dimensiRequestRef.current) {
          console.error("Gagal mengambil dimensi:", err);
          setGetDataDimensi([]);
          setForm2((prev) => ({ ...prev, ysb_dimensi_id: "" }));
        }
      } finally {
        if (isMounted.current && requestId === dimensiRequestRef.current) {
          setLoadingDimensi(false);
        }
      }
    };

    fetchDimensi();
    return () => controller.abort();
  }, [
    form2.ysb_semester_id,
    form2.ysb_grade_level_id,
    selectedSemester,
    storageBranch,
    storageSchoolId,
    storageLevel,
    fetchParams,
    loadingLevel,
    getDataLevel.length,
  ]);

  // =========================
  // Fetch master: Tingkatan (berdasarkan ysb_school_id) + Kelas (berdasarkan tingkatan)
  // =========================
  const fetchLevels = useCallback(async () => {
    // wajib ada schoolId
    if (!storageSchoolId) return;

    const controller = new AbortController();
    abortControllers.current.push(controller);

    setLoadingLevel(true);

    try {
      const levelRes = await APIMS.get(
        `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${storageBranch || ""}&level=${storageLevel || ""}&ysb_school_id=${storageSchoolId}`,
        { ...fetchParams, signal: controller.signal }
      );

      if (!isMounted.current) return;

      if (levelRes?.status === 200) {
        let levels = levelRes.data?.data || [];

        // Filter by ysb_school_id (frontend)
        const hasSchoolField = levels.some((x) => x?.ysb_school_id);
        if (hasSchoolField) {
          levels = levels.filter((x) => {
            const sid = x?.ysb_school_id;
            return String(sid) === String(storageSchoolId);
          });
        }

        // Sort A -> Z (numeric aware: SD 1, SD 2, SMP 7, dst)
        levels.sort((a, b) => collator.compare(safeStr(a?.name_level), safeStr(b?.name_level)));
        setGetDataLevel(levels);

        // Default: pilih tingkatan pertama saat pertama kali load
        if (levels.length > 0) {
          setForm2((prev) => (prev?.ysb_grade_level_id ? prev : { ...prev, ysb_grade_level_id: levels[0].id }));
        }
      }
    } catch (err) {
      swal({
        title: "Gagal",
        text: err?.response?.data?.message || err.message || "Gagal mengambil master tingkatan",
        icon: "error",
      });
    } finally {
      setLoadingLevel(false);
    }
  }, [ascending, collator, fetchParams, limit, page, storageBranch, storageLevel, storageSchoolId]);

  const fetchKelasByLevel = useCallback(
    async (gradeLevelId) => {
      if (!storageSchoolId || !gradeLevelId) return;

      const controller = new AbortController();
      abortControllers.current.push(controller);

      setLoadingKelas(true);

      try {
        // NOTE: tetap kirim branch & level untuk kompatibilitas, + grade_level_id untuk sesuai request
        const kelasRes = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${storageBranch || ""}&level=${storageLevel || ""}&ysb_school_id=${storageSchoolId}&ysb_grade_level_id=${gradeLevelId}`,
          { ...fetchParams, signal: controller.signal }
        );

        if (!isMounted.current) return;

        if (kelasRes?.status === 200) {
          let kelas = kelasRes.data?.data || [];

          // Filter by school (frontend)
          const hasSchoolField = kelas.some((x) => x?.ysb_school_id);
          if (hasSchoolField) {
            kelas = kelas.filter((x) => {
              const sid = x?.ysb_school_id;
              return String(sid) === String(storageSchoolId);
            });
          }

          // Filter by grade level (frontend)
          const hasLevelField = kelas.some(
            (x) =>
              x?.ysb_grade_level_id 
             
          );
          if (hasLevelField) {
            kelas = kelas.filter((k) => {
              const kelasLevelId =
                k?.ysb_grade_level_id 
              return String(kelasLevelId) === String(gradeLevelId);
            });
          }

          kelas.sort((a, b) => collator.compare(safeStr(a?.name_kelas), safeStr(b?.name_kelas)));
          setGetDataKelas(kelas);

          // Default: pilih kelas pertama (berdasarkan tingkatan terpilih)
          setForm2((prev) => {
            const currentId = prev?.ysb_kelas_id;
            const exists = !!currentId && kelas.some((k) => String(k?.id) === String(currentId));
            if (exists) return prev;
            return { ...prev, ysb_kelas_id: kelas[0]?.id || "" };
          });
        }
      } catch (err) {
        swal({
          title: "Gagal",
          text: err?.response?.data?.message || err.message || "Gagal mengambil master kelas",
          icon: "error",
        });
      } finally {
        setLoadingKelas(false);
      }
    },
    [ascending, collator, fetchParams, limit, page, storageBranch, storageLevel, storageSchoolId]
  );

  useEffect(() => {
    fetchLevels();
  }, [fetchLevels]);

  // Kelas selalu ngikut tingkatan yang dipilih
  useEffect(() => {
    if (!form2.ysb_grade_level_id) return;
    fetchKelasByLevel(form2.ysb_grade_level_id);
  }, [form2.ysb_grade_level_id, fetchKelasByLevel]);


  // =========================
  // Filter complete (untuk tombol Cari)
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_dimensi_id &&
    !!form2.ysb_grade_level_id &&
    !!form2.ysb_kelas_id;

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
    if (!form2.ysb_semester_id || !form2.ysb_dimensi_id) return;

    const params = {
      ysb_semester_id: form2?.ysb_semester_id,
      level: storageLevel,
      branch: storageBranch,
      ysb_dimensi_id: form2?.ysb_dimensi_id,
      ysb_school_id: storageSchoolId,
      // filter tambahan (kalau backend support akan otomatis)
      ysb_grade_level_id: form2?.ysb_grade_level_id || undefined,
      ysb_kelas_id: form2?.ysb_kelas_id || undefined,
    };

    try {
      const response = await APILA.get("/api/leger-head/head", {
        params,
        ...fetchParams,
      });

      if (response?.status === 200) {
        setGetData(response.data.data || []);
      }
    } catch (error) {
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data",
        icon: "error",
      });
    }
  }, [form2, fetchParams, storageBranch, storageLevel, storageSchoolId]);

  // AUTO SELECT TAB (tetap dipertahankan)
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // FIRST LOAD: tampilkan table otomatis setelah default filter lengkap
  useEffect(() => {
    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_dimensi_id ||
      !form2.ysb_grade_level_id ||
      !form2.ysb_kelas_id
    )
      return;

    firstLoadDone.current = true;

    (async () => {
      setIsFetching(true);
      await GetResponseData(); // ✅ HANYA SEKALI
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  }, [
    form2.ysb_semester_id,
    form2.ysb_dimensi_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    GetResponseData,
  ]);

  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [form2.ysb_semester_id, form2.ysb_dimensi_id, form2.ysb_grade_level_id, form2.ysb_kelas_id]);

  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => {
      // kalau tingkatan berubah, reset kelas
      if (name === "ysb_grade_level_id") {
        return { ...prev, ysb_grade_level_id: value, ysb_kelas_id: "" };
      }
      return { ...prev, [name]: value };
    });

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi (biar user jelas)
    if (!form2.ysb_semester_id || !form2.ysb_dimensi_id) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);
    setSearchKeyword("");

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };

  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);
  
  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
    
  const handleOpenModal = (element, rekap) => {
    setDataModal({
      name_element: element?.name_element,
      description: element?.description,
      kkca_description: rekap?.kkca_description,
      name_student: rekap?.name_student,
      nisn: rekap?.nisn,
    
      // ⬇️ metadata utk simpan input capaian (kolom Karyawan / Adab)
      ysb_dimensi_id: element?.ysb_dimensi_id,
      ysb_element_id: element?.id,
      ysb_semester_id: rekap?.ysb_semester_id,
      ysb_school_id: rekap?.ysb_school_id,
      ysb_branch_id: rekap?.ysb_branch_id,
    
      ysb_teacher_id: rekap?.ysb_teacher_id,
    
      ysb_student_id: rekap?.ysb_student_id,
      ysb_kelas_id: rekap?.ysb_kelas_id,
      ysb_element_recap_id: rekap?.ysb_element_recap_id,
    
      sub_elements: rekap?.sub_elements || [],
    });
    setShowModal(true);
  };



  // =========================
  // Derived: opsi kelas (bila data kelas punya foreign key tingkatan)
  // =========================
  const kelasOptions = useMemo(() => {
    if (!form2.ysb_grade_level_id) return getDataKelas;

    const levelId = form2.ysb_grade_level_id;
    return (getDataKelas || []).filter((k) => {
      const kelasLevelId =
        k?.ysb_grade_level_id

      // kalau field tidak ada, jangan disaring (biar tetap tampil semua)
      if (!kelasLevelId) return true;
      return String(kelasLevelId) === String(levelId);
    });
  }, [form2.ysb_grade_level_id, getDataKelas]);

 
  // =========================
  // Filter + Search + Sorting (frontend)
  // - Filter tingkatan/kelas diterapkan dari frontend 
  // - Nama siswa diurutkan A -> Z
  // =========================
 

  //  const filterSortRekapan = useCallback(
  //   (rekapanList = []) => {
  //     let rows = Array.isArray(rekapanList) ? [...rekapanList] : [];

  //     const q = safeStr(searchKeyword).trim().toLowerCase();
  //     if (q) {
  //       rows = rows.filter((r) => {
  //         const name = safeStr(r?.name_student).toLowerCase();
  //         const nisn = safeStr(r?.nisn).toLowerCase();
  //         return name.includes(q) || nisn.includes(q);
  //       });
  //     }

  //     rows.sort((a, b) => collator.compare(safeStr(a?.name_student), safeStr(b?.name_student)));
  //     return rows;
  //   },
  //   [collator, searchKeyword]
  // );

  const filterSortRekapan = useCallback(
    (rekapanList = []) => {
      let rows = Array.isArray(rekapanList) ? [...rekapanList] : [];

      const q = safeStr(searchKeyword).trim().toLowerCase();
      if (q) {
        rows = rows.filter((r) => {
          const name = safeStr(r?.name_student).toLowerCase();
          const nisn = safeStr(r?.nisn).toLowerCase();
          return name.includes(q) || nisn.includes(q);
        });
      }

      // SORT:
      // siswa lama A-Z di atas, siswa baru order_absen di bawah
      rows.sort((a, b) => {
        const orderA =
          a?.order_absen === null ||
          a?.order_absen === undefined ||
          a?.order_absen === ""
            ? null
            : Number(a.order_absen);

        const orderB =
          b?.order_absen === null ||
          b?.order_absen === undefined ||
          b?.order_absen === ""
            ? null
            : Number(b.order_absen);

        const aIsNew = orderA !== null && !Number.isNaN(orderA);
        const bIsNew = orderB !== null && !Number.isNaN(orderB);

        if (!aIsNew && bIsNew) return -1;
        if (aIsNew && !bIsNew) return 1;

        if (aIsNew && bIsNew) {
          if (orderA !== orderB) return orderA - orderB;

          const nameCompare = collator.compare(
            safeStr(a?.name_student),
            safeStr(b?.name_student)
          );

          if (nameCompare !== 0) return nameCompare;

          return collator.compare(
            safeStr(a?.nisn),
            safeStr(b?.nisn)
          );
        }

        const nameCompare = collator.compare(
          safeStr(a?.name_student),
          safeStr(b?.name_student)
        );

        if (nameCompare !== 0) return nameCompare;

        return collator.compare(
          safeStr(a?.nisn),
          safeStr(b?.nisn)
        );
      });

      return rows;
    },
    [collator, searchKeyword]
  );

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };
  
  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body leger-page">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faRectangleList} />
              </span>
              <h4 className="page-title-text">Leger</h4>
            </div>
          </div>

          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-head">Beranda</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li className="custom-breadcrumb-item active" aria-current="page">
                Leger
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content leger-content mt-2">
          <section className="leger-filter-card">
            <div className="leger-filter-header">
              {/* <div className="leger-filter-title-wrap">
                <span className="leger-filter-icon">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <div>
                  <h3 className="leger-filter-title">Filter Leger</h3>
                  <p className="leger-filter-subtitle">
                    Pilih semester, tingkatan, kelas, dan dimensi.
                  </p>
                </div>
              </div> */}
            </div>

            {loading ? (
              <div className="leger-filter-grid leger-filter-grid-head">
                {Array.from({ length: 4 }).map((_, index) => (
                  <div className="leger-filter-field" key={`leger-head-shimmer-${index}`}>
                   
                    <div className="shimmer leger-filter-shimmer-control" />
                  </div>
                ))}
                <div className="leger-filter-field leger-filter-action">
                  <div className="shimmer leger-filter-shimmer-control" />
                </div>
              </div>
            ) : (
              <div className="leger-filter-grid leger-filter-grid-head">
                <div className="leger-filter-field">
                  <label className="leger-filter-label">Semester</label>
                  <select
                    className="leger-filter-select"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      {namaTA} (Semester {namaSmstr})
                    </option>
                    {getDataSemesterMap.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_year} (Semester {user?.semester})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="leger-filter-field">
                  <label className="leger-filter-label">Tingkatan</label>
                  <select
                    className="leger-filter-select"
                    name="ysb_grade_level_id"
                    value={form2.ysb_grade_level_id}
                    onChange={handleChange}
                    disabled={loadingLevel}
                  >
                    <option value="" hidden>
                      {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                    </option>
                    {!loadingLevel &&
                      getDataLevel.map((lv, index) => (
                        <option key={index} value={lv?.id}>
                          {lv?.name_level}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="leger-filter-field">
                  <label className="leger-filter-label">Kelas</label>
                  <select
                    className="leger-filter-select"
                    name="ysb_kelas_id"
                    value={form2.ysb_kelas_id}
                    onChange={handleChange}
                    disabled={loadingKelas}
                  >
                    <option value="" hidden>
                      {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                    </option>
                    {!loadingKelas &&
                      kelasOptions.map((kls, index) => (
                        <option key={index} value={kls?.id}>
                          {kls?.name_kelas}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="leger-filter-field">
                  <label className="leger-filter-label">Dimensi</label>
                  <select
                    className="leger-filter-select"
                    name="ysb_dimensi_id"
                    value={form2.ysb_dimensi_id}
                    onChange={handleChange}
                    disabled={loadingDimensi || getDataDimensi.length === 0}
                  >
                    <option value="" hidden>
                      {loadingDimensi ? "Memuat dimensi..." : getDataDimensi.length === 0 ? "Belum ada dimensi" : "Pilih Dimensi"}
                    </option>
                    {getDataDimensi.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_dimensi}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="leger-filter-field leger-filter-action">
                  <button
                    type="button"
                    onClick={handleCari}
                    disabled={!isFilterComplete}
                    className="btn leger-filter-button"
                  >
                    Cari
                  </button>
                </div>
              </div>
            )}
          </section>

          {isFetching && (
            <div className="leger-loading">
              <PulseLoader color="#3f5bea" size={12} />
            </div>
          )}

          {hasSearched && !isFetching && (
            <Tabs
              id="leger-tabs-head"
              activeKey={selectedTab}
              onSelect={(k) => setSelectedTab(k)}
              className="leger-tabs"
            >
              {(getData?.[0]?.data_element || []).map((element, eIdx) => {
                const rows = filterSortRekapan(element?.rekapan);

                return (
                  <Tab
                    key={element?.id || eIdx}
                    eventKey={element?.name_element}
                    title={element?.name_element}
                  >
                    <div className="leger-element-description">
                      <h5>{element?.description}</h5>
                    </div>

                    <div className="leger-search-wrap">
                      <FontAwesomeIcon icon={faMagnifyingGlass} className="leger-search-icon" />
                      <input
                        className="leger-search-input"
                        placeholder="Cari Siswa / NISN"
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                      />
                    </div>

                    <div className="leger-table-card">
                      <div className="leger-table-scroll">
                        <table className="leger-table">
                          <thead>
                            <tr>
                              <th className="leger-col-number">No</th>
                              <th className="leger-col-name">Nama</th>
                              <th className="leger-col-nisn">NISN</th>
                              <th className="leger-col-score">Nilai</th>
                              <th className="leger-col-kkca">KKCA</th>
                              <th className="leger-col-description">Deskripsi</th>
                            </tr>
                          </thead>

                          <tbody>
                            {rows.length === 0 ? (
                              <tr>
                                <td colSpan={6} className="leger-empty-state">
                                  Data siswa tidak ditemukan
                                </td>
                              </tr>
                            ) : (
                              rows.map((rekap, idx) => (
                                <tr key={rekap?.ysb_element_recap_id || idx}>
                                  <td className="leger-col-number">
                                    <span className="leger-number-badge">{idx + 1}</span>
                                  </td>
                                  <td className="leger-col-name">
                                    <button
                                      type="button"
                                      className="leger-student-button"
                                      onClick={() => handleOpenModal(element, rekap)}
                                    >
                                      {toTitleCase(rekap?.name_student)}
                                    </button>
                                  </td>
                                  <td className="leger-col-nisn leger-cell-center">
                                    {rekap?.nisn || "-"}
                                  </td>
                                  <td className="leger-col-score leger-cell-center">
                                    {rekap?.average ?? "-"}
                                  </td>
                                  <td className="leger-col-kkca leger-cell-center">
                                    {rekap?.kkca_description || "-"}
                                  </td>
                                  <td className="leger-col-description leger-cell-description">
                                    {rekap?.kkca_description_full || "-"}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <ModalLeger
                      show={showModal}
                      onHide={() => setShowModal(false)}
                      data_leger={dataModal}
                    />
                  </Tab>
                );
              })}
            </Tabs>
          )}
        </div>
      </div>
    </>
  );
}
